import React from 'react'
import PropTypes from 'prop-types'
import { Table as AntTable } from 'antd'
import { LIMIT } from '../../../../services/graphql/queries'

const Table = ({
  noPagination = false,
  bordered = false,
  data = null,
  itemsPerPage = LIMIT,
  loading = false,
  totalCount = 20,
  columns,
  components,
  onChange,
  rowClassName,
  pagination,
  expandable,
  // Default to horizontal scroll so wide tables stay inside the viewport and
  // the right-most columns (e.g. Actions) remain reachable. Override per-table.
  scroll = { x: 'max-content' },
  ...restProps
}) => {
  const currentPagination = noPagination
    ? false
    : {
        position: 'bottomCenter',
        current: pagination?.current,
        total: totalCount,
        showTotal: total => `Total: ${total}`,
        showLessItems: false,
        defaultPageSize: itemsPerPage
      }
  return (
    <AntTable
      {...restProps}
      components={components}
      tableLayout="auto"
      bordered={bordered}
      rowClassName={rowClassName}
      loading={loading}
      columns={columns}
      dataSource={data}
      onChange={onChange}
      expandable={expandable}
      scroll={scroll}
      pagination={currentPagination}
    />
  )
}

Table.propTypes = {
  bordered: PropTypes.bool,
  columns: PropTypes.array.isRequired,
  components: PropTypes.object,
  expandable: PropTypes.object,
  data: PropTypes.array,
  itemsPerPage: PropTypes.number,
  loading: PropTypes.bool,
  onChange: PropTypes.func,
  rowClassName: PropTypes.func,
  totalCount: PropTypes.number,
  pagination: PropTypes.object,
  noPagination: PropTypes.bool,
  scroll: PropTypes.object
}

export default Table
